module.exports = __webpack_public_path__ + "static/media/layoutHorizontal.7ea94e26.svg";